import React from 'react'
import QueryEditor from './QueryEditor'

function QueryToolHome () {
  return (
    <QueryEditor />
  )
}

export default QueryToolHome
